// consider separate, small css:
// import "../styles/frontPage.scss";

import $ from 'jquery';
// const $ = require('jquery');
global.$ = global.jQuery = $;
window.$ = window.jQuery = $;
import "bootstrap/dist/js/bootstrap.bundle";
import "jquery-toast-plugin";
import { handleCookieBar } from './cookieBar.js';
import { showToastAlerts } from './alerts.js';


(function($) {

    const isMobile = ('ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/))
    if(isMobile){
        $('body').addClass('mobile');
    } else {
        $('body').addClass('desktop');
    }

    // Pretty checkbox
    $(".form-check label input, .form-radio label input").after('<i class="input-helper"></i>');

    showToastAlerts($('.toast-alert'));

    handleCookieBar();

    // Stop the video playback in the modal (only if the modal exists)
    const videoModal = document.getElementById('videoGuideModal');
    if (videoModal) {
        const videoIframe = videoModal.querySelector('iframe');
        if (videoIframe) {
            videoModal.addEventListener('hidden.bs.modal', function() {
                // Reload the iframe to stop playback
                const currentSrc = videoIframe.src;
                videoIframe.src = '';
                videoIframe.src = currentSrc;
            });
        }
    }

})(jQuery);